import { useState, useEffect } from 'react';
import { User } from '../types';
import apiService from '../services/api';

interface AuthState {
    isAuthenticated: boolean;
    token?: string;
    user?: User;
}

export const useAuth = () => {
    const [auth, setAuth] = useState<AuthState>(() => {
        const savedAuth = localStorage.getItem('auth');
        return savedAuth ? JSON.parse(savedAuth) : { isAuthenticated: false };
    });

    useEffect(() => {
        localStorage.setItem('auth', JSON.stringify(auth));
    }, [auth]);

    useEffect(() => {
        // Initialize API service token if user is already authenticated
        if (auth.isAuthenticated && auth.token) {
            apiService.setToken(auth.token);
        } else {
            apiService.setToken(null);
        }
    }, [auth.isAuthenticated, auth.token]);

    const login = (token: string, user: User) => {
        setAuth({ isAuthenticated: true, token, user });
        // The useEffect will handle setting the token in apiService
    };

    const logout = () => {
        setAuth({ isAuthenticated: false });
        localStorage.removeItem('auth');
        apiService.setToken(null);
    };

    return {
        isAuthenticated: auth.isAuthenticated,
        token: auth.token,
        user: auth.user,
        login,
        logout,
    };
}; 